var render = function render(){
  var _vm$crntItem;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "approvalRequestPopupWrap",
    class: _vm.status.approvalRequestPopupViewBln ? 'active' : null,
    on: {
      "click": _vm.dimmedClickHandler
    }
  }, [_c('div', {
    ref: "contentWrap",
    staticClass: "contentWrap"
  }, [_c('h2', [_vm._v("외원회 승인 요청")]), _c('dl', {
    staticClass: "titleInfo"
  }, [_c('dt', [_vm._v(_vm._s((_vm$crntItem = _vm.crntItem) === null || _vm$crntItem === void 0 ? void 0 : _vm$crntItem.fieldName))]), _c('dd', [_c('span', [_vm._v(_vm._s(_vm.PROCESS_INFO.processName))])])]), _c('dl', {
    staticClass: "reasonInfo"
  }, [_c('dt', [_vm._v("신청사유")]), _c('dd', [_c('p', {
    staticClass: "placeholder",
    class: _vm.str != '' ? 'hidden' : null
  }, [_vm._v("위원회 승인 담당자가 확인 필요한 수정 사항 및"), _c('br'), _vm._v("요청 사유를 입력하세요.")]), _c('p', {
    ref: "requestInput",
    staticClass: "textarea",
    attrs: {
      "role": "textbox",
      "contenteditable": ""
    },
    on: {
      "input": _vm.typeHandler
    }
  })])]), _c('p', {
    staticClass: "explain"
  }, [_vm._v("위원회 승인 시 해당 문서가 공개됩니다.")]), _c('div', {
    staticClass: "btns"
  }, [_c('btn-link', {
    style: {
      minWidth: '60px'
    },
    on: {
      "click": _vm.cancelHandler
    }
  }, [_vm._v("취소")]), _c('btn-link', {
    style: {
      minWidth: '80px'
    },
    attrs: {
      "color": "blue"
    },
    on: {
      "click": _vm.requestHandler
    }
  }, [_vm._v("요청하기")])], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }